import { ArrowRightIcon } from '@heroicons/react/outline';
import clsx from 'clsx';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import PromoPic from '@/assets/products-hero-picture.png';
import { Button } from '@/components/Elements';

export type PromoCardProps = {
  className?: string;
};

export const PromoCard = ({ className }: PromoCardProps) => {
  const { t } = useTranslation();

  const onActionClick = () => window.location.assign('/account/products');

  return (
    <div
      className={clsx(
        `w-full pt-8 rounded-lg border-2 border-md-mediumGray m-auto overflow px-4 pt-2 pb-6 ${className}`
      )}
    >
      <div className="text-lg font-bold uppercase text-black text-center leading-6 mb-4">
        {t('PromoCard.title')}
      </div>
      <img title="Promo" src={PromoPic} alt="Promo" />
      <Button
        className="m-auto mt-10 py-2 lg:py-4 text-xs lg:text-sm rounded-full"
        variant="primary"
        size="free"
        type="button"
        title={t('RequestAccountHero.actionButton')}
        onClick={onActionClick}
        endIcon={<ArrowRightIcon className="h-5 w-5 text-white mr-6" aria-hidden="true" />}
      >
        {t('PromoCard.actionButton')}!
      </Button>
    </div>
  );
};
